import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
    name: 'user',
    initialState: { 
       meta : {}
       ,isLoadingMeta : false
       ,activeInteraction : ''
    }
    ,reducers : {
        setUserMeta : (state, action) => {
            state.meta[action.payload.metaKey] = action.payload.metaValue;
        }
        ,setIsLoadingMeta : (state, action) => {
            state.isLoadingMeta = action.payload;
        }
        ,setActiveInteraction : (state, action) => {
            state.activeInteraction = action.payload;
        }
    }
});

export default userSlice.reducer;